module.exports = "<div>\n\t<i class=\"far fa-check-circle fa-lg px-1 mx-2\"></i>{{ msg }}\n</div>"